import { ActionTypes } from "@/App/constants/actionTypes";
import { PlanTypes, GeneralTypes } from "@/types";

type SearchForPlansAction = {
  type: typeof ActionTypes.SEARCH_FOR_PLAN_LIST;
  payload: GeneralTypes.QueryOptions;
  formName: string;
};

export const searchForPlans = (data: { data: GeneralTypes.QueryOptions; formName: string }): SearchForPlansAction => {
  return {
    type: ActionTypes.SEARCH_FOR_PLAN_LIST,
    payload: data.data,
    formName: data.formName,
  };
};

type SearchForPlansResultsAction = {
  type: typeof ActionTypes.SEARCH_FOR_PLAN_LIST_RESULTS;
  payload: PlanTypes.PlanSearchResponse;
};

export const searchForPlansResults = (data: PlanTypes.PlanSearchResponse): SearchForPlansResultsAction => {
  return {
    type: ActionTypes.SEARCH_FOR_PLAN_LIST_RESULTS,
    payload: data,
  };
};

export type PlanSearchActions = SearchForPlansAction | SearchForPlansResultsAction;
